
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 3a.5.5 0 00-1 0v2h-1a1 1 0 00-1 1v3a2 2 0 00-2 2v7a2 2 0 002 2v9.5a2.5 2.5 0 005 0V20a2 2 0 002-2v-7a2 2 0 00-2-2V6a1 1 0 00-1-1h-1V3zm-2 3v3h3V6h-3zm3 23.5V20h-3v9.5a1.5 1.5 0 003 0zM8 11a1 1 0 011-1h5a1 1 0 011 1v7a1 1 0 01-1 1H9a1 1 0 01-1-1v-7zM18.5 18H20v2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2v-8a2 2 0 00-2-2v-2h1.5a.5.5 0 000-1h-9a.5.5 0 000 1zm6.5 0h-4v2h4v-2zm-5 3h6a1 1 0 011 1v8a1 1 0 01-1 1h-6a1 1 0 01-1-1v-8a1 1 0 011-1z","fill":"#000"}})])
          )
        }
      }
    